export default class StringHelper {
    isNullOrEmpty(value) {
        return value == null || value === undefined || value.trim() === "";
    }

    castToEnum(value, enumType) {
        if (typeof value !== 'string' || !enumType) {
            return null;
        }
        return value.toEnum(enumType);
    }
}
// Helper function


String.prototype.toEnum = function (enumType) {

    const upperCaseStr = this.toUpperCase();
    for (const key in enumType) {
        if (enumType[key].toUpperCase() === upperCaseStr) {
            return enumType[key];
        }
    }
    return null; // Eğer eşleşme bulunamazsa null döndürün
};

